export const getDateDaysAgo = (daysAgo: number) => {
  const today = new Date();
  const daysAgoDate = new Date(today);
  daysAgoDate.setDate(today.getDate() - daysAgo);
  return daysAgoDate.toUTCString();
};

export const compassErrorClassName = 'shadow-[0_0_0_5px_rgba(220,38,38,0.2)]';
